// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__2dFlM","accountManagement":"styles_accountManagement__3aqli"};